import { DatapointStatus } from 'owa-analytics';
import startImageLoadPerfDataPoint from './startImageLoadPerfDataPoint';

/**
 * Log image load
 * @param type The type
 * @param howLoad How the image is loaded
 * @param error The error, when absent means success
 * @param context The context
 * @param loaderCode The loader code
 */
export default function logImageLoadPerfData(
    type: string,
    howLoad: string,
    error: string = '',
    context: string = '',
    loaderCode: string = '',
    field1: string = ''
) {
    const inlineImageLoad = startImageLoadPerfDataPoint();
    const cd = [type, howLoad, error, context, loaderCode, field1];
    inlineImageLoad.addCustomData(cd);
    if (error && error.length > 0) {
        inlineImageLoad.endWithError(DatapointStatus.ClientError);
    } else {
        inlineImageLoad.end();
    }
}
